import React from 'react';
import { TextReveal } from './TextReveal';
const steps = [{
  id: '01',
  title: 'ANALYSE',
  description: 'Tiefgehende Analyse Ihrer aktuellen Gesellschaftsstruktur und Identifikation von Chancen und Optimierungspotenzialen.'
}, {
  id: '02',
  title: 'STRATEGIE',
  description: 'Entwicklung einer maßgeschneiderten Beratungsstrategie mit klaren Meilensteinen.'
}, {
  id: '03',
  title: 'UMSETZUNG',
  description: 'Hands-on Implementierung aller Maßnahmen in enger Abstimmung.'
}, {
  id: '04',
  title: 'KONTROLLE',
  description: 'Laufende Überwachung und Anpassung für nachhaltige Ergebnisse.'
}];
export function Process() {
  return <section className="py-24 md:py-32 bg-bg relative overflow-hidden" data-id="element-83">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10" data-id="element-84">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-85">
          <div className="md:col-span-3" data-id="element-86">
            <TextReveal text="PROZESS" as="h2" className="text-xs md:text-sm font-mono uppercase tracking-[0.3em] text-muted sticky top-26" data-id="element-87" />
          </div>

          <div className="md:col-span-9 grid grid-cols-1 gap-16 md:gap-24" data-id="element-88">
            {steps.map(step => <div key={step.id} className="relative pl-0 md:pl-8 border-l border-white/10 md:border-none" data-id="element-89">
                <div className="absolute -left-4 md:-left-12 top-0 opacity-10 select-none pointer-events-none hidden md:block" data-id="element-90">
                  <span className="text-9xl font-black text-white leading-none tracking-tighter" data-id="element-91">
                    {step.id}
                  </span>
                </div>

                <div className="relative pl-6 md:pl-0" data-id="element-92">
                  <span className="md:hidden text-4xl font-black text-white/20 mb-2 block" data-id="element-93">
                    {step.id}
                  </span>
                  <TextReveal text={step.title} as="h3" className="text-2xl md:text-3xl font-bold text-white mb-4 uppercase" data-id="element-94" />
                  <TextReveal text={step.description} as="p" className="text-base text-muted max-w-md leading-relaxed" delay={0.1} data-id="element-95" />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}